<template>
  <img :class="props.class" :style="props.style" v-bind="props.attrs" :alt="alt">
  </img>
</template>
<script setup>
import { reactive, computed, ref, toRaw, onMounted, watch } from "vue";

const props = defineProps({
  data: String,
  class: String,
  style: String,
  attrs: Object,
})

const alt = ref(props.attrs?.alt)

onMounted(() => {
  if (!props.attrs?.alt) {
    alt.value = document.title
  }
})
</script>
<style lang="">
  
</style>